module.exports = __webpack_public_path__ + "public/img/rzlc.f6a4e238.png";